import * as React from "react";
export const SidebarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 22 22" {...props}>
    <path d="M2 0h18a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm15 2v18h3V2h-3z" />
  </svg>
);
